<template>
  <div class="relative" :class="{ [custom]: !!custom }">
    <bb-hidden-input
      v-model="model"
      :name="name"
      type="checkbox"
      class="flex cursor-pointer items-center gap-10 peer-disabled:cursor-default peer-checked:[&>.checkbox>svg]:!block peer-checked:[&>.checkbox]:border-blue-500 peer-checked:[&>.checkbox]:bg-blue-500 peer-disabled:[&>.checkbox]:!border-gray-400 peer-disabled:[&>.checkbox]:bg-gray-100 peer-disabled:[&>.checkbox]:dark:!border-gray-600 peer-disabled:[&>.checkbox]:dark:bg-gray-800"
      :class="{
        'peer-checked:[&>.checkbox]:!border-[--bb-checkbox__border--checked] peer-checked:[&>.checkbox]:!bg-[--bb-checkbox__bg--checked] peer-checked:[&>.checkbox]:dark:!border-[--bb-checkbox__border--checked-dark] peer-checked:[&>.checkbox]:dark:!bg-[--bb-checkbox__bg--checked-dark]':
          !!custom,
      }"
      :disabled="disabled"
      :value="value"
      :unchecked-value="false"
    >
      <slot name="label">
        <div
          class="checkbox rounded-4 flex h-16 w-16 shrink-0 items-center justify-center border border-gray-200 bg-white dark:border-gray-600 dark:bg-black"
          :class="{
            '!border-red-500': !!hasErrors || hasManualError,
            [`${custom} border-[--bb-checkbox__border] dark:border-[--bb-checkbox__border--dark]`]: !!custom,
          }"
        >
          <local-font-awesome-icon
            class="text-11 !hidden pt-[1px]"
            :icon="faCheck"
            :class="{
              [`${custom} !text-[--bb-checkbox__icon] dark:!text-[--bb-checkbox__icon--dark]`]: !!custom,
              'text-gray-400': disabled,
              'text-white': !disabled,
            }"
          />
        </div>
        <div v-bind="$attrs">
          <slot />
        </div>
      </slot>
    </bb-hidden-input>
    <error-message class="text-11 absolute left-0 top-full pt-4 text-red-500" :name="name" />
  </div>
</template>

<script lang="ts" setup generic="V extends number | string | undefined">
/*
 * Needs to be wrapped inside a div otherwise the peer selector would select all checkboxes inside a checkbox array
 */

import { faCheck } from '@fortawesome/pro-solid-svg-icons';
// rename to prevent name collision with global registered component
import { FontAwesomeIcon as LocalFontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ErrorMessage, useField } from 'vee-validate';

import BbHiddenInput from './BbHiddenInput.vue';

const {
  name,
  custom = '',
  value = true,
  hasManualError = false,
} = defineProps<{
  name: string;
  value?: V;
  disabled?: boolean;
  hasManualError?: boolean;

  custom?: string;
}>();

defineOptions({ inheritAttrs: false });

const model = defineModel<V extends undefined ? boolean : Array<V>>({ required: true });

const hasErrors = useField(name).errorMessage;
</script>
